import { ObjectValues } from 'types/common';

export const DATA_SOURCE_FORM_NAMES = {
  Clients: 'clients',
  ExternalLists: 'external-lists',
  Lists: 'lists',
  MasterFile: 'master-file',
  ThirdParty: 'third-party',
  UseClientLists: 'use-client-lists',
} as const;

export type DataSourceFormNames = ObjectValues<typeof DATA_SOURCE_FORM_NAMES>;
export const DataSourceFormNameKeys = Object.values(DATA_SOURCE_FORM_NAMES);
